import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const printPackingSlipInputSchema = z.intersection(
  z.union([
    z.object({ fulfillmentGroupIds: z.array(z.string()) }),
    z.object({ batchId: z.string() }),
  ]),
  z.object({
    workstationId: z.string().optional(),
    templateId: z.string().optional(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    printFast: z.boolean().nullish(),
    idempotencyKey: z.string().optional(),
    initiationTime: z.number().nullish(),
  }),
);

export type PrintPackingSlipInput = z.infer<typeof printPackingSlipInputSchema>;
